import React, { useEffect, useState } from "react";
import { RegistrationDataGridCols } from "./data-grid-cols";
import { ApisService } from "../../../app/core/apis.service";
import { dataDecrypt, encrypt } from "../../../app/utility/encryption-helper";
import { DataTable } from "../../../components/data-table";
import moment from "moment";
import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { getMonthStartAndEndDates } from "../../../app/utility/monthStartEndDate";

export const RegistrationDetails = () => {
  const { startDate, endDate } = getMonthStartAndEndDates();
  const [loading, setLoading] = useState<boolean>(false);
  const [toggleData, setToggleData] = useState<any>();
  const [inputValue, setInputValue] = useState("");
  const [fromDate, setFromDate] = useState<any>(startDate);
  const [toDate, setToDate] = useState<any>(endDate);
  const [show, setShow] = useState(false);
  const initialPayload = { filters: { limit: 10, page: 0, startDate: startDate, endDate: endDate } }
  const [pageCount, setPageCount] = useState<any>(initialPayload);
  const [registrationData, setRegistrationData] = useState<any>([]);

  useEffect(() => {
    loadUsers(initialPayload);
  }, []);

  async function loadUsers(data: any): Promise<void> {
    setLoading(true);
    try {
      let encrytedData = encrypt(JSON.stringify(data));
      const res = await ApisService.usersApi("getAll", encrytedData);
      const registrationData = JSON.parse(dataDecrypt(res.data.data));
      const response = registrationData?.results;
      response?.forEach((el: any) => {
        el.date = moment(el.created_date).format("DD-MM-YYYY");
        el.no_of_bu = el?.business_units?.length > 0 ? el.business_units.length : 0;
      });
      setRegistrationData(registrationData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(`${error}`);
    }
  }

  const closePopup = () => {
    setShow(false);
    loadUsers(pageCount);
    setToggleData("");
  };


  const updateStatus = async (confirmation: any) => {
      let payload = {
        id: toggleData?._id,
        status: toggleData?.status,
      };
      let encrytedData = encrypt(JSON.stringify(payload));
      try {
        const res = await ApisService.usersApi("updateStatus", encrytedData);
        if(res){
          setShow(false);
        }
      } catch (error) {
        toast.error(`${error}`);
      }
    loadUsers(pageCount);
  };
  const searchData = () => {
    let payload = { filters: { limit: 10, page: 0, search: inputValue, startDate: fromDate, endDate: toDate } };
    setPageCount(payload);
    loadUsers(payload);
  }

  const handleClose = () => {
    setInputValue("");
    setFromDate(startDate);
    setToDate(endDate);
    setPageCount(initialPayload);
    loadUsers(initialPayload);
  }

  const selectFromDate = (e: any) => {
    setFromDate(e.target.value);
  }

  const selectToDate = (e: any) => {
    setToDate(e.target.value)
  }

  const onSelectPaginator = (data: any) => {
    const pageData = { ...pageCount, page: data };
    let payload = { filters: { limit: pageData.filters.limit, page: data,search: inputValue,startDate: fromDate, endDate: toDate } }
    setPageCount(payload);
    loadUsers(payload);
  };


  const handleChange = (e: any) => {
    let payload = { filters: { limit: 10, page: 0, search: e.target.value,startDate: fromDate, endDate: toDate } };
    loadUsers(payload);
    setInputValue(e.target.value);
  }

  const onActions=(data:any)=>{
    if(data.type==="toggle"){
      setShow(true);
      setToggleData(data?.data);
    }
  }

  return (
    <div
      className={`container-fluid content-bg-color ${show ? "blur-background" : ""
        }`}
    >
      <h4 className="primary-color fw-bold mt-3">Registrations</h4>
      <div className="row">
        <input type="text" className="form-control rounded-pill" value={inputValue} onChange={handleChange} placeholder="Search ..." />
        <div className="row mt-2">
          <div className="col-md-5 mb-2 ps-0">
            <input type="date" className="form-control" value={fromDate} onChange={selectFromDate} />
          </div>
          <div className="col-md-5 mb-2">
            <input type="date" className="form-control" value={toDate} min={fromDate} onChange={selectToDate} />
          </div>
          <div className="col-md-1 mb-2"><button className="form-control primary-bg text-white w-100" onClick={searchData}>Search</button></div>
          <div className="col-md-1 mb-2"><button className="form-control primary-bg text-white w-100" onClick={handleClose}>Clear</button></div>
        </div>
      </div>
      <div className="px-0 my-2">
        {loading && (
          <div className="text-center p-5">
            <div className="spinner-border" role="status">
              <span className="sr-only"></span>
            </div>
          </div>
        )}
        {!loading && (
          <DataTable
            tableData={registrationData}
            TableCols={RegistrationDataGridCols}
            pagination={true}
            pageCount={pageCount}
            onSelectPageChange={(e) => onSelectPaginator(e)}
            onActions={(e)=>onActions(e)}
          />
        )}
      </div>
      <Modal show={show} centered onHide={closePopup}>
        <Modal.Body className="text-center">
          <div className="fs-5 mb-2">
            Are you sure want to{" "}
            {toggleData?.status ? (
              <span className="fw-bold">Activate</span>
            ) : (
              <span className="fw-bold">De-Activate</span>
            )}{" "}
            user
          </div>
          <button
            className="w-25 rounded bg-white primary-border primary-color"
            onClick={() => closePopup()}
          >
            NO
          </button>
          <button
            className="w-25 ms-2 rounded primary-bg border text-white"
            onClick={() => updateStatus("yes")}
          >
            YES
          </button>
        </Modal.Body>
      </Modal>
    </div>
  );
};
